var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mail-detail-integration" } },
    [
      _c("div", { staticClass: "section-title" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("mail.integrationForwardingSettingsTitle")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "integration-card" }, [
        _c("div", { staticClass: "integration-header" }, [
          _c("div", { staticClass: "integration-icon" }, [_c("MailIcon")], 1),
          _vm._v(" "),
          _c("div", { staticClass: "integration-info" }, [
            _c("div", { staticClass: "integration-name" }, [
              _vm._v(_vm._s(_vm.$t("mail.integrationGmailForwardTitle"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "integration-description" }, [
              _vm._v(_vm._s(_vm.$t("mail.integrationGmailForwardDesc"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "integration-body" }, [
          _c(
            "div",
            {
              staticClass: "integration-button",
              on: { click: _vm.openGmailModal },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("info")]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("mail.integrationHowToForward")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "integration-items" },
            _vm._l(_vm.forwardAddresses, function (address) {
              return _c(
                "div",
                { key: address._id, staticClass: "integration-item" },
                [
                  _c(
                    "div",
                    { staticClass: "item-icon" },
                    [_c("MailIcon", { staticClass: "icon-mail" })],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-tooltip", { attrs: { title: address.mail } }, [
                    _c("div", { staticClass: "item-mail" }, [
                      _vm._v(_vm._s(address.mail)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-actions" }, [
                    _c(
                      "span",
                      {
                        staticClass: "material-icons action-icon delete",
                        on: {
                          click: function ($event) {
                            return _vm.confirmDeleteForward(address)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                            delete\n                        "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "integration-card" }, [
        _c("div", { staticClass: "integration-header" }, [
          _c(
            "div",
            { staticClass: "integration-icon" },
            [_c("MicrosoftIcon")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "integration-info" }, [
            _c("div", { staticClass: "integration-name" }, [
              _vm._v(_vm._s(_vm.$t("mail.integrationOutlookForwardTitle"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "integration-description" }, [
              _vm._v(_vm._s(_vm.$t("mail.integrationOutlookForwardDesc"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "integration-body" }, [
          _c(
            "div",
            {
              staticClass: "integration-button",
              on: { click: _vm.openOutlookModal },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("info")]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("mail.integrationHowToForward")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "integration-items" },
            [
              _c(
                "div",
                {
                  staticClass: "integration-item new-item",
                  on: {
                    click: function ($event) {
                      return _vm.openForwardModal("microsoft")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("add_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("mail.integrationAddManualForward"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.microsoftForwardAddresses, function (address) {
                return _c(
                  "div",
                  { key: address._id, staticClass: "integration-item" },
                  [
                    _c(
                      "div",
                      { staticClass: "item-icon" },
                      [_c("MailIcon", { staticClass: "icon-mail" })],
                      1
                    ),
                    _vm._v(" "),
                    _c("a-tooltip", { attrs: { title: address.mail } }, [
                      _c("div", { staticClass: "item-mail" }, [
                        _vm._v(_vm._s(address.mail)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(1, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "item-actions" }, [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons action-icon delete",
                          on: {
                            click: function ($event) {
                              return _vm.confirmDeleteForward(address)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            delete\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "integration-card" }, [
        _c("div", { staticClass: "integration-header" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "integration-info" }, [
            _c("div", { staticClass: "integration-name" }, [
              _vm._v(_vm._s(_vm.$t("mail.integrationOtherProvidersTitle"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "integration-description" }, [
              _vm._v(_vm._s(_vm.$t("mail.integrationOtherProvidersDesc"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "integration-body" }, [
          _c(
            "div",
            { staticClass: "integration-items" },
            [
              _c(
                "div",
                {
                  staticClass: "integration-item new-item",
                  on: {
                    click: function ($event) {
                      return _vm.openForwardModal("other")
                    },
                  },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("add_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("mail.integrationAddManualForward"))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.otherForwardAddresses, function (address) {
                return _c(
                  "div",
                  { key: address._id, staticClass: "integration-item" },
                  [
                    _c(
                      "div",
                      { staticClass: "item-icon" },
                      [_c("MailIcon", { staticClass: "icon-mail" })],
                      1
                    ),
                    _vm._v(" "),
                    _c("a-tooltip", { attrs: { title: address.mail } }, [
                      _c("div", { staticClass: "item-mail" }, [
                        _vm._v(_vm._s(address.mail)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(3, true),
                    _vm._v(" "),
                    _c("div", { staticClass: "item-actions" }, [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons action-icon delete",
                          on: {
                            click: function ($event) {
                              return _vm.confirmDeleteForward(address)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            delete\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.isGmailModalVisible
        ? _c(
            "Modal2",
            {
              staticClass: "mail-instruction-modal",
              attrs: {
                title: _vm.$t("mail.integrationGmailStepsTitle"),
                "show-footer": false,
                "show-title": false,
              },
              on: { cancel: _vm.closeGmailModal },
            },
            [
              _c("div", { staticClass: "modal-header" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("mail.integrationGmailStepsTitle"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-video-container" },
                [
                  _c("GifPlayer", {
                    attrs: {
                      src: "https://static.supsis.live/common/email/screenshot/gmail.mp4",
                      autoplay: true,
                      loop: true,
                      muted: true,
                      controls: false,
                      width: "100%",
                      height: "auto",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "" },
                      on: { click: _vm.closeGmailModal },
                    },
                    [_vm._v(_vm._s(_vm.$t("mail.modalOk")))]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isOutlookModalVisible
        ? _c(
            "Modal2",
            {
              staticClass: "mail-instruction-modal",
              attrs: {
                title: _vm.$t("mail.integrationOutlookStepsTitle"),
                "show-footer": false,
                "show-title": false,
              },
              on: { cancel: _vm.closeOutlookModal },
            },
            [
              _c("div", { staticClass: "modal-header" }, [
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("mail.integrationOutlookStepsTitle"))),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-video-container" },
                [
                  _c("GifPlayer", {
                    attrs: {
                      src: "https://static.supsis.live/common/email/screenshot/outlook.mp4",
                      autoplay: true,
                      loop: true,
                      muted: true,
                      controls: false,
                      width: "100%",
                      height: "auto",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "SupsisButton",
                    {
                      attrs: { primary: "" },
                      on: { click: _vm.closeOutlookModal },
                    },
                    [_vm._v(_vm._s(_vm.$t("mail.modalOk")))]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showForwardModal
        ? _c(
            "Modal2",
            {
              staticClass: "mail-forward-modal",
              attrs: {
                title: _vm.$t("mail.integrationAddForwardTitle"),
                "show-footer": false,
                "show-title": false,
              },
              on: { cancel: _vm.handleForwardModalCancel },
            },
            [
              _c("div", { staticClass: "modal-header" }, [
                _c("h3", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("mail.integrationAddForwardHeading", {
                        type: _vm.forwardForm.type.toUpperCase(),
                      })
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-form" }, [
                _c("div", { staticClass: "form-description" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("mail.integrationForwardFormHelp")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "sourceEmail" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.integrationSourceEmailLabel"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "input-container",
                      class: {
                        error:
                          _vm.forwardForm.sourceEmail &&
                          !_vm.isValidSourceEmail,
                      },
                    },
                    [
                      _c("span", { staticClass: "input-icon" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("mail"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.forwardForm.sourceEmail,
                            expression: "forwardForm.sourceEmail",
                          },
                        ],
                        attrs: {
                          type: "email",
                          id: "sourceEmail",
                          placeholder: _vm.$t(
                            "mail.integrationEmailExamplePlaceholder"
                          ),
                          required: "",
                        },
                        domProps: { value: _vm.forwardForm.sourceEmail },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.forwardForm,
                              "sourceEmail",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.forwardForm.sourceEmail && !_vm.isValidSourceEmail
                    ? _c("div", { staticClass: "error-message" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("mail.integrationInvalidEmail")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "destinationEmail" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.integrationDestinationLabel"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("span", { staticClass: "input-icon" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("forward_to_inbox"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forwardForm.destinationEmail,
                          expression: "forwardForm.destinationEmail",
                        },
                      ],
                      attrs: {
                        type: "email",
                        id: "destinationEmail",
                        readonly: "",
                      },
                      domProps: { value: _vm.forwardForm.destinationEmail },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.forwardForm,
                            "destinationEmail",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "owner" } }, [
                    _vm._v(_vm._s(_vm.$t("mail.integrationOwnerLabel"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-container" }, [
                    _c("span", { staticClass: "input-icon" }, [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.forwardForm.owner,
                          expression: "forwardForm.owner",
                        },
                      ],
                      attrs: { type: "text", id: "owner", readonly: "" },
                      domProps: { value: _vm.forwardForm.owner },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.forwardForm,
                            "owner",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _c(
                      "SupsisButton",
                      { on: { click: _vm.handleForwardModalCancel } },
                      [_vm._v(_vm._s(_vm.$t("mail.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: "", disabled: !_vm.isFormValid },
                        on: { click: _vm.handleFormModalSave },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("common.save")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-status" }, [
      _c("span", { staticClass: "material-icons status-icon verified" }, [
        _vm._v("verified"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-status" }, [
      _c("span", { staticClass: "material-icons status-icon verified" }, [
        _vm._v("verified"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "integration-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("mail")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-status" }, [
      _c("span", { staticClass: "material-icons status-icon verified" }, [
        _vm._v("verified"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }